@import '../../global-styles/index.scss';

:host {
  display: inline-block;
}

.chip {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  align-items: center;
  background-color: #FEEAE3;
  color: #E03600;
  font-family: $typography-family-sans;
  font-size: 13px;
  font-weight: 700;
  line-height: 125%;
  border-radius: 999px;
  white-space: nowrap;
}
